<template>
    <div class="mx-xs md:mx-md lg:mx-lg">
        <v-breadcrumbs class="mx-sm mb-md mt-sm sm:container sm:mx-auto" />

        <v-storyblok-story v-if="story"
            :story="story" />
    </div>
</template>

<script setup lang="ts">
import type { ISbStoryData } from 'storyblok-js-client';

const route = useRoute();

const fullSlug = route.path === '/' || route.path === '' ? 'home' : route.path;

const story = ref<ISbStoryData>();

try {
    const data = await useAsyncStoryblokStory(fullSlug, {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        resolve_relations: [
            'sb-brands-listing.content',
            'sb-brands-listing-big.content',
        ].join(','),
    });

    if (!data) {
        throw new Error('Page Not Found');
    }

    story.value = data;
} catch {
    throw createError({ statusCode: 404, statusMessage: 'Page Not Found' });
}

useSeoMeta({
    title: story.value?.content.meta?.title || story.value?.name,
    ogTitle: story.value?.content.meta?.title || story.value?.name,
    description: story.value?.content.meta?.description ?? undefined,
    ogDescription: story.value?.content.meta?.description ?? story.value?.content?.short_description ?? undefined,
});
</script>
